import { connect } from 'react-redux';
import { checkLoadingSelector } from 'services/store/base/selectors';
import { tagSelection, tagActionNames } from 'services/store/tags/actions';
import type { ITag } from 'services/api/entities';
import MobileTagsList from './MobileTagsList';
// @ts-ignore
const mapStateToProps = ({ base, tags }) => ({
  tagStore: tags,
  isLoading: checkLoadingSelector(base, [tagActionNames.TAG_GET_LIST]),
});
// @ts-ignore
const mapDispatchToProps = (dispatch) => ({
  selectTag: (tag: ITag): void => {
    dispatch(tagSelection({ tag }));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileTagsList);
